<div class="container">
    <div class="inner">
        <div class="col gap-16">
            <div class="info-icon">
                <rr-icon name="info"></rr-icon>
            </div>
            <h2 i18n>What information will be shared?</h2>
        </div>
        <div class="col gap-24">
            <div>We only transmit the data strictly required to 
                up and manage your landing page on Easy2.
            </div>
            <div class="col gap-16">
                <div class="bullet">
                    <div class="bullet-icon">
                        <rr-icon name="arrow-right"></rr-icon>
                    </div>
                    <div class="bullet-text">
                        <h4>Email and User Name</h4>
                        <div>This information will be used to set up your free account at Easy2.</div>
                    </div>
                </div>
                <div class="bullet">
                    <div class="bullet-icon">
                        <rr-icon name="arrow-right"></rr-icon>
                    </div>
                    <div class="bullet-text">
                        <h4>AI-Generated content</h4>
                        <div>Textual content generated by AI during your BUsiness Idea Stream.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="close" (click)="closeDialog()">
        <rr-icon name="close"></rr-icon>
    </div>
</div>